import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateCarrierContactActions } from "store/ducks/settings/carrier-contact";

export function* paginateCarrierContactRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/carrier-contact?${queryString}`
    );

    const { carrierContact, pagination } = responseBody;
    yield put(PaginateCarrierContactActions.success(carrierContact, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateCarrierContactActions.failure(errorMessage));
  }
}
